import { render, staticRenderFns } from "./slideregion1.vue?vue&type=template&id=2e3570ab&scoped=true&"
import script from "./slideregion1.vue?vue&type=script&lang=js&"
export * from "./slideregion1.vue?vue&type=script&lang=js&"
import style0 from "./slideregion1.vue?vue&type=style&index=0&id=2e3570ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3570ab",
  null
  
)

export default component.exports